import { Col, Container, Row } from "react-bootstrap";

const styles = {
  wrapper: {
    height: '100vh',
    backgroundImage: "url('/background-image.avif')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
  },
};

const WelComePage = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.overlay}>
        <Container>
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <h1 className="mb-4">🚧 Website Coming Soon</h1>
              <p className="lead fs-5">
                We're launching our new website soon. Stay tuned!
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default WelComePage;
